<template>
    <div></div>
</template>

<script>
/**
 * @see https://gist.github.com/pedrohma/11f425655b534fa729fb931b1db47db0
 */
export default {
    data: () => ({}),

    created() {},

    mounted() {},

    computed: {},

    methods: {}
}
</script>

<style lang="scss" scoped>
</style>
